import { render, staticRenderFns } from "./AppNavbarLanding.vue?vue&type=template&id=fb23206e&scoped=true&"
import script from "./AppNavbarLanding.vue?vue&type=script&lang=ts&"
export * from "./AppNavbarLanding.vue?vue&type=script&lang=ts&"
import style0 from "./AppNavbarLanding.vue?vue&type=style&index=0&id=fb23206e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb23206e",
  null
  
)

export default component.exports